import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import { Market } from "./component/trade/market";

export function MarketClient() {
  const [searchParams] = useSearchParams();

  const theme = searchParams.get("theme") || "light";

  return (
    <div data-theme={theme} className={clsx("h-full", {})}>
      <Market />
    </div>
  );
}
